/**
 * Хелперы для подготовки границ периода для бэкенда (LocalDateTime, без таймзоны).
 *
 * Бэкенд принимает ISO_LOCAL_DATE_TIME (например, `2026-05-31T23:59:59`).
 * Используем строки в локальной таймзоне браузера, без `Z` и без смещения.
 */

const pad = (n) => String(n).padStart(2, '0');

/** YYYY-MM-DD (для значения `<input type="date" />`). */
export function toDateInputValue(date) {
    if (!date) return '';
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** Начало дня в локальной таймзоне → строка `YYYY-MM-DDT00:00:00`. */
export function startOfDayLocal(dateInputValue) {
    if (!dateInputValue) return '';
    return `${dateInputValue}T00:00:00`;
}

/** Конец дня в локальной таймзоне → строка `YYYY-MM-DDT23:59:59`. */
export function endOfDayLocal(dateInputValue) {
    if (!dateInputValue) return '';
    return `${dateInputValue}T23:59:59`;
}

/** Первый день текущего месяца как `Date`. */
export function firstDayOfCurrentMonth() {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
}

/** Сегодняшняя дата без времени как `Date`. */
export function today() {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Первый день предыдущего месяца как `Date`. */
export function firstDayOfPreviousMonth() {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth() - 1, 1);
}

/** Последний день предыдущего месяца как `Date`. */
export function lastDayOfPreviousMonth() {
    const d = new Date();
    // 0-й день месяца == последний день предыдущего.
    return new Date(d.getFullYear(), d.getMonth(), 0);
}
